import React, { useEffect, useState, useMemo } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import { Bar, Chart } from 'react-chartjs-2';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { setCurrencyFormat } from '../../../../utils/helpers';

const colorData = Obj =>
  Obj.map((element) => {
    const max = Math.max(...Obj);
    const opecity = Math.floor(element) / max;
    const color = `rgba(102, 204, 166, ${opecity})`;
    return color;
  });
const color = 'rgb(102, 204, 166)';
const options = {
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        let label = data.datasets[tooltipItem.datasetIndex].label || '';

        if (label) {
          label += ': ';
        }

        // eslint-disable-next-line max-len
        label += setCurrencyFormat(tooltipItem.yLabel.toFixed(2), true); // Math.round(tooltipItem.yLabel * 100) / 100;
        return label;
      },
    },
  },
  datalabels: {
    display: true,
    color: '#000',
    font: {
      weight: 500,
      size: 7,
    },
  },
  legend: {
    display: false,
  },

  // Core options
  layout: {
    padding: {
      top: 24,
      right: 16,
      bottom: 0,
      left: 8,
    },
  },
  elements: {
    line: {
      fill: false,
    },
    point: {
      hoverRadius: 7,
      radius: 5,
    },
  },
  scales: {
    xAxes: [
      {
        stacked: true,
      },
    ],
    yAxes: [
      {
        stacked: true,
        /* ticks: {
         callback: function (label, index, labels) {
            return setCurrencyFormat(label);
        },
    }, */
      },
    ],
  },
};

const YearBars = (props) => {
  const { title, revenueData, setModel, isLoading } = props;
  const { t } = useTranslation('common');
  const addMonthlyAmount = (total, num) => (Number(total) + Number(num)).toFixed(2);
  const [currentYearTotalAmount, setCurrentYearTotalAmount] = useState(0);
  const [previousYearTotalAmount, setPreviousYearTotalAmount] = useState(0);
  const reduceArray = (obj) => {
    if (obj && obj.length > 0) {
      return obj.reduce(addMonthlyAmount);
    }
    return 0;
  };  

  const { yearArray, yearData } = useMemo(() => {
  const years = [];
  if (revenueData && revenueData.length > 0) {
    revenueData.forEach((innerObj) => {
      if (!years.includes(innerObj.salesYear)) {
        years.push(innerObj.salesYear);
      }
    });
  }  

  const data = [];
  years.forEach((ele) => {
    data.push(
      reduceArray(revenueData.filter(x => x.salesYear === ele).map(item => item.amount)),
    );
  });

  return { yearArray: years, yearData: data };
}, [revenueData]);

const chartData = useMemo(() => {
  return {
    labels: yearArray,
    datasets: [
      {
        label: '',
        borderColor: color,
        borderWidth: 1,
        hoverBackgroundColor: color,
        hoverBorderColor: color,
        backgroundColor: colorData(yearData),
        data: yearData,
        datalabels: {
          align: 'end',
          anchor: 'end',
          fontSize: 7,
          font: {
            weight: 500,
            size: 10,
          },
          formatter: value => `${setCurrencyFormat(value || '0.00', true)}`,
        },
      },
    ],
  };
}, [yearArray, yearData]);

const [data, setData] = useState(chartData);

  // const yearArray = [];
  // if (revenueData && revenueData.length > 0) {
  //   revenueData.forEach((innerObj) => {
  //     if (!yearArray.includes(innerObj.salesYear)) {
  //       yearArray.push(innerObj.salesYear);
  //     }
  //   });
  // }  

  // const yearData = [];
  // yearArray.forEach((ele) => {
  //   yearData.push(
  //     reduceArray(revenueData.filter(x => x.salesYear === ele).map(data => data.amount)),
  //   );
  // });

  // const getYear = () => ({
  //   labels: yearArray,
  //   datasets: [
  //     {
  //       label: '',
  //       borderColor: color,
  //       borderWidth: 1,
  //       hoverBackgroundColor: color,
  //       hoverBorderColor: color,
  //       backgroundColor: colorData(yearData),
  //       data: yearData,
  //       datalabels: {
  //         align: 'end',
  //         anchor: 'end',
  //         fontSize: 7,
  //         font: {
  //           weight: 500,
  //           size: 10,
  //         },
  //         formatter: value => `${setCurrencyFormat(value || '0.00', true)}`,
  //       },
  //     },
  //   ],
  // });
  // const [data, setData] = useState(getYear());

  useEffect(() => {
     // Fix: Only update data if we have valid data
    if (yearArray.length > 0 && yearData.length > 0) {    
      setData(chartData);
      // setData(title === 'Monthly Sales' ? getYear() : getYear);
    }
    if (revenueData && revenueData.length > 0) {
      setCurrentYearTotalAmount(
        revenueData
          .filter(item => Number(item.salesYear) === new Date().getFullYear())
          .map(item => item.amount)
          .reduce((a, b) => Number(a) + Number(b), 0)
          .toFixed(2),
      );
      setPreviousYearTotalAmount(
        revenueData
          .filter(item => Number(item.salesYear) === new Date().getFullYear() - 1)
          .map(item => item.amount)
          .reduce((a, b) => Number(a) + Number(b), 0)
          .toFixed(2),
      );
    }
    }, [revenueData, chartData, yearArray.length, yearData.length]);
  // }, [revenueData, yearArray, yearData, title]);

  const getPercentage = (currValue, preValue) =>
    (((currValue - preValue) / preValue) * 100).toFixed(2) || '0.00';
  const totalAmount = reduceArray(revenueData?.map(x => x.amount));
  const totalAmounts = (totalAmount / 1000000).toFixed(2);

  // Fix: Add validation for revenueData
  if (!revenueData || !Array.isArray(revenueData) || revenueData.length === 0) {
    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <CardBody className="card-shadow">
            <div className="card__title">
              <h5 className="bold-text">{t(title)}</h5>
            </div>
            <div className="text-center p-4">
              <p>No data available for {title}</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  // Fix: Add validation for yearArray
  if (yearArray.length === 0) {
    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <CardBody className="card-shadow">
            <div className="card__title">
              <h5 className="bold-text">{t(title)}</h5>
            </div>
            <div className="text-center p-4">
              <p>No yearly data available</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col md={12} lg={12} xl={12}>
      <Card>
        <CardBody className=" card-shadow">
          {isLoading ? (<>
            <div className="card__title">
              <h5 className="bold-text">{t(title)}</h5>
            </div>
            <div
              style={{ minHeight: '200px' }}
              className="row align-items-center justify-content-center"
            >
              <SmallLoader loading={isLoading} />
            </div>
          </>
          ) : (<> <div className="card__title">
            <h5 className="bold-text">{t(title)}</h5>
            <button id='btnYearlyViewReport'
              type="button"
              className="view-report btn btn-primary btn-sm"
              onClick={() => setModel(true)}
            >
              View Report
            </button>
          </div>
            <div className="second-header-for-chart">
              <div className="left">
                <h5 className="bold-text colored">$ {totalAmounts} Million</h5>
                <h5 className="bold-text">{t('Total Amount')}</h5>
              </div>
              <div className="right">
                {getPercentage(currentYearTotalAmount, previousYearTotalAmount) < 0 && (
                  <h5 className="bold-text colored">
                    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,
                        14.29L22,12V18H16Z"
                      />
                    </svg>
                    {getPercentage(currentYearTotalAmount, previousYearTotalAmount)}%
                  </h5>
                )}
                {getPercentage(currentYearTotalAmount, previousYearTotalAmount) > 0 && (
                  <h5 className="bold-text colored">
                    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,
                        12L13.41,16L19.71,9.71L22,12V6H16Z"
                      />
                    </svg>
                    {getPercentage(currentYearTotalAmount, previousYearTotalAmount)}%
                  </h5>
                )}
                <h5 className="bold-text">{t('Since last year')}</h5>
              </div>
            </div>
            <Bar data={data} options={options} />
          </>)}
        </CardBody>
      </Card>
    </Col>
  );
};
YearBars.propTypes = {
  title: PropTypes.string.isRequired,
  revenueData: PropTypes.array || [],
  setModel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired

};

export default YearBars;
